export default "/dist/files/pdf.77dae73a9f3e1eb94a462062d266f36b.svg";